module.exports = __webpack_public_path__ + "img/OverseaMember57.2f468ace.jpg";